import Icon from '@/components/icons/Icon';
import { IconVariant } from '@/components/icons/types';
import React from 'react';
import { twMerge } from 'tailwind-merge';

type CategoryButtonProps<T extends React.ElementType = 'button'> = {
  as?: T;
  label: string;
  icon?: IconVariant;
  onClick?: () => void;
  className?: string;
} & Omit<
  React.ComponentPropsWithoutRef<T>,
  keyof { as?: T; label: string; icon?: IconVariant; selected?: boolean; onClick?: () => void; className?: string }
>;

const CategoryButton = <T extends React.ElementType = 'button'>({
  as,
  label,
  icon,
  onClick,
  className,
  ...rest
}: CategoryButtonProps<T>) => {
  const Component = as || 'button';

  return (
    <Component
      onClick={onClick}
      className={twMerge(
        'gap-2xs px-sm text-bg_neutral py-xs inline-flex items-center rounded-full outline-none transition-colors focus-visible:outline',
        'bg-bg_neutral drop-shadow-xs border border-current',
        'hover:border-border_bold hover:drop-shadow-sm',
        'active:bg-bg_secondary_hover active:border-bg_secondary_hover active:drop-shadow-none',
        className,
      )}
      {...rest}>
      {icon && <Icon variant={icon} style={{ width: 20, height: 20 }} color="fg_secondary" />}
      <span className="text-m text-fg_secondary whitespace-nowrap">{label}</span>
    </Component>
  );
};

export default CategoryButton;
